import { FC } from 'react';

import { Redirect, RedirectProps } from 'react-router-dom';

interface AppRedirectProps extends RedirectProps {
  path?: string;
}

const AppRedirect: FC<AppRedirectProps> = ({ path = '*', ...props }) => <Redirect path={path} {...props} />;

export default AppRedirect;
